export default __webpack_public_path__ + "static/media/room1_2.ae8f80c1.jpeg";